import { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";
import { toast } from "react-toastify";
import "./admin.css";
import "./ManageUsers.css";

function ManageUsers() {
  const [users, setUsers]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized. Please login again.");
      setLoading(false);
      return;
    }

    axiosClient
      .get("/admin/users", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (Array.isArray(res.data))            setUsers(res.data);
        else if (Array.isArray(res.data.users)) setUsers(res.data.users);
        else toast.error("Invalid response format");
      })
      .catch(() => toast.error("Error loading users"))
      .finally(() => setLoading(false));
  }, []);

  if (loading)
    return (
      <div className="admin-spinner-wrap">
        <div className="admin-spinner-ring" />
        <p className="admin-spinner-label">Loading users…</p>
      </div>
    );


  return (
    <>
      <div className="admin-page-header">
        <h1>Users</h1>
        <p>{users.length} registered user{users.length !== 1 ? "s" : ""}</p>
      </div>

      {users.length === 0 ? (
        <div className="admin-empty">
          <div className="empty-icon"></div>
          <p>No users found.</p>
        </div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u, idx) => (
                <tr key={u._id}>
                  <td style={{ color: "var(--muted)", fontSize: 13 }}>{idx + 1}</td>
                  <td style={{ fontWeight: 600 }}>{u.name}</td>
                  <td style={{ color: "var(--muted)" }}>{u.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default ManageUsers;
